import { render, staticRenderFns } from "./SubFolderEmpty.vue?vue&type=template&id=0ed89ece&scoped=true&"
import script from "./SubFolderEmpty.vue?vue&type=script&lang=js&"
export * from "./SubFolderEmpty.vue?vue&type=script&lang=js&"
import style0 from "./SubFolderEmpty.vue?vue&type=style&index=0&id=0ed89ece&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed89ece",
  null
  
)

export default component.exports